Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    colors = _STYLES$useStyles.colors,
    fontRegular = _STYLES$useStyles.fontRegular;
  var heading = {
    marginBottom: spacing.m
  };
  var benefitItem = {
    flexDirection: 'row'
  };
  var benefitItemTick = {
    borderRadius: 9999,
    backgroundColor: colors.alternative,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    flexDirection: 'row'
  };
  var benefitItemTextContainer = {
    marginLeft: spacing.m,
    marginBottom: 0,
    flex: 1
  };
  var benefitItemText = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    flex: 1
  });
  var styles = _reactNative.StyleSheet.create({
    heading: heading,
    benefitItem: benefitItem,
    benefitItemText: benefitItemText,
    benefitItemTextContainer: benefitItemTextContainer,
    benefitItemTick: benefitItemTick
  });
  return {
    styles: styles
  };
};